<template>
    <results-page-feasibility v-if="isAdmin"></results-page-feasibility>
    <results-page v-else></results-page>
</template>

<script>
    import ResultsPage from './ResultsPage.vue'
    import ResultsPageFeasibility from './ResultsPageFeasibility.vue'

    export default {
        components: {
            ResultsPage,
            ResultsPageFeasibility,
        },

        computed: {
            isAdmin() {
                return this.$auth.isUserAdministrator()
            },
        },
    }
</script>
